import SmvContrast from "./components/smv-contrast";
import SmvContact from "./components/smv-contact";
import SmvQuotes from "./components/smv-quotes";
import SmvProjects from "./components/smv-projects";
import SmvCarousel from "./components/smv-carousel";
import SmvIcon from "./components/smv-icon";
import SmvVideo from "./components/smv-video";

import BarbaJs from "./features/barba-js";
new BarbaJs();

// // create the scrollSmoother before your scrollTriggers
// ScrollSmoother.create({
//   smooth: 1, // how long (in seconds) it takes to "catch up" to the native scroll position
//   effects: true, // looks for data-speed and data-lag attributes on elements
//   smoothTouch: 0.1, // much shorter smoothing time on touch devices (default is NO smoothing on touch devices)
// });

document.documentElement.classList.replace('no-js', 'js');
